var subscribe = function() {
    // console.log('running vue-subscribe')


    var container = document.querySelector('.subscribe__modal_container')
    var close = document.querySelector('.subscribe__close')
    var closeX = document.querySelector('.subscribe__x')
    var subLinks = document.querySelectorAll('a[href="#subscribe"]')

    // initialize if loading a #subscribe link:
    if (window.location.hash.substr(1) === 'subscribe') {   
        document.querySelector('#vue-subscribe').focus()
        container.classList.add('open')
        document.body.classList.add('noscroll')
    }

    closeX.addEventListener('click', function () {
        container.classList.remove('open')
        document.body.classList.remove('noscroll')
    })
    close.addEventListener('click', function () {
        container.classList.remove('open')
        document.body.classList.remove('noscroll')
    })
    subLinks.forEach(function(element) {
        element.addEventListener('click', function() {
            document.querySelector('#vue-subscribe').focus()
            container.classList.add('open')
            document.body.classList.add('noscroll')
        })
    })

    var urlParams = new URLSearchParams(window.location.search);

    new Vue({
        el: '#vue-subscribe',
        delimiters: ['${', '}'],
        data: function() {
            return {
                step: 1,
                box: null,
                frequency: '',
                size: '',
                chart: false,
                timestamp: (new Date()).getTime(),
                slots: {},
                selectedChoice: 0
            }
        },
        mounted: function() {
            this.getSlots()
        },
        computed: {
            c_size: function () {
                if (this.size === 'small') {
                    return '31347745751098'
                } else if (this.size === 'medium') {
                    return '30871240179770'
                } else {
                    return
                }
            },
            cleanSlots: function() {
                return this.slots
            },
            selectedChoiceObject: function() {
                if (this.selectedChoice === 0) {
                    return
                } else {
                    const obj = this.slots.filter(slot => {
                        return slot.id === this.selectedChoice
                    })
                    return obj[0]
                }
            },
            selectedProduct: function() {
                if (this.selectedChoice === 0) {
                    return 0
                } else {
                    const obj = this.slots.filter(slot => {
                        return slot.id === this.selectedChoice
                    })
                    return obj[0].product.product_id
                }
            },
            selectedVariant: function() {
                if (this.selectedChoice === 0) {
                    return 0
                } else {
                    const obj = this.slots.filter(slot => {
                        return slot.id === this.selectedChoice
                    })
                    return obj[0].product.variant_id
                }
            }
        },
        methods: {
            getSlots: function () {
                axios.get('https://ro.boldapps.net/api/widget/group/154949/build_a_box/slots?shop=consciousstep.myshopify.com').then(response => {
                    // console.log(response.data.slots)
                    this.slots = response.data.slots;
                });
            },
            selectChoice: function (slotId) {
                this.selectedChoice = slotId
                console.log(slotId)
            },
            getImage: function (product) {
                if (product.shopify_details.image !== null ) {
                    return product.shopify_details.image.src
                } else {
                    var images = product.shopify_details.full.images
                    const result = images.filter(image => {
                        return image.variant_ids.includes(product.variant_id)
                    })
                    if (result === null) {
                        return ''
                    } else {
                        return result[0] ? result[0].src : ''
                    }
                }

            },
            back: function () {
                if (this.step === 1) {
                    return
                } else {
                    this.step = this.step - 1
                }
            },
            close: function () {
                var container = document.querySelector('.subscribe__modal_container')
                container.classList.remove('open')
                document.body.classList.remove('noscroll')
            },
            closeChart: function () {
                this.chart = !this.chart
            }
        },
        watch: {
            message: function (value) {
                if (value) {
                    console.log(value)
                } else {
                    console.log('no value')
                }
            },
            selectedChoice: function (value) {
                // console.log(value)
                if (document.querySelectorAll(`[data-slot-quantity]`)) {
                    document.querySelectorAll(`[data-slot-quantity]`).forEach(function(element) {
                        element.value = 0
                    })
                    document.querySelector(`[data-slot-quantity="${value}"]`).value = 1
                } else {
                    return
                }
            }
        },
    })
}

var closeQuick = function() {
    // console.log('closeQuick')
    var closeTrigger = document.querySelectorAll('.js-close_quick')
    // var overlay = document.querySelector('.js-overlay')

    // console.log(closeTrigger)
    // console.log(overlay)

    // closeTrigger.addEventListener('click', function () {
    //     console.log('overlay')
    //     overlay.click()
    // })

    closeTrigger.forEach(function(element) {
        element.addEventListener('click', function() {
            document.querySelector('.js-overlay').click()
        })
    })
}

var sizeGuide = function() {
    console.log('running prouct-size-guide')
    var size_guides = document.querySelectorAll('[data-size-guide-trigger]')
    size_guides.forEach(function(element) {

        var thisFrame = element.parentElement.querySelector('[data-size-guide-frame]')
        var thisGuides = thisFrame.querySelectorAll('[data-size-guide]')

        element.addEventListener('click', function() {
            thisFrame.classList.add('fadeIn')
            thisFrame.classList.remove('conceal')
        })

        thisGuides.forEach(function(el) {
            el.addEventListener('click', function() {
                el.parentElement.classList.remove('fadeIn')
                el.parentElement.classList.add('conceal')
            })
        })

    })
}


var cartLog = function() {

    var subtotalTarget = document.querySelector('.js-subtotal');
    var freeShippingContainer = document.querySelector('.js-free_shipping');
    var freeShippingDiff = document.querySelector('.js-free_shipping__diff');
    var freeShippingProgress = document.querySelector('[data-free-shipping-progress]');

    // create a new instance of `MutationObserver` named `observer`, 
    // passing it a callback function
    var observer = new MutationObserver(function() {

        // console.log(freeShippingContainer)
        var freeShippingTarget = parseInt(freeShippingContainer.dataset.freeShippingTarget, 10)
        // console.log(freeShippingTarget)

        jQuery.ajax({
            url: '/cart.js',
            dataType: 'json'
        })
        .done(function(data){
            var subtotal = data.items_subtotal_price;
            if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
            BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
            }
            // console.log(subtotal);
            updateShippingBar(freeShippingTarget, subtotal)
        });

        // Create our number formatter.
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        
            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0,
            //maximumFractionDigits: 0,
        });
  

        var updateShippingBar = function (target, subtotal) {
            if (subtotal >= target) {
                // console.log('congrats')
                freeShippingContainer.classList.add('goal')
                freeShippingProgress.style.setProperty('--progress', 100)
            } else {
                // console.log('not yet')
                freeShippingContainer.classList.remove('goal')
                freeShippingDiff.innerHTML = formatter.format((target - subtotal) / 100 )
                freeShippingProgress.style.setProperty('--progress', Math.floor((subtotal / target) * 100))
            }
        }

    });

    // call `observe()` on that MutationObserver instance, 
    // passing it the element to observe, and the options object
    observer.observe(subtotalTarget, {subtree: true, childList: true});
    
}

document.addEventListener('DOMContentLoaded', function() {
    cartLog()
    if (document.querySelector('#vue-subscribe')) {
        subscribe()
    }
    if (document.querySelector('.js-close_quick')) {
        closeQuick()
    }
    if (document.querySelector('[data-size-guide-trigger]')) {
        sizeGuide()
    }
})

document.addEventListener('cc-opencart', function (e) {
  document.querySelector('.quick-cart').classList.add('is-active');
  document.querySelector('.quick-cart').classList.add('is-visible');
}, true);  